// extracted by mini-css-extract-plugin
export var actions = "_sp-4";
export var item = "_sp-1";
export var price = "_sp-3";
export var quantity = "_sp-2";
export var table = "_sp-0";